package one.healthium.url_provider.domain

interface UrlProviderRepository {
    suspend fun get(type: UrlType): String?
}

enum class UrlType {
    Terms,
    Privacy,
    Legal
}